import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import ErrorBoundary from './components/composite/ErrorBoundary/ErrorBoundary.jsx';

const root = createRoot(document.getElementById('root'));

const app = (
    <ErrorBoundary>
        <App />
    </ErrorBoundary>
);

// Only wrap in StrictMode during development
if (import.meta.env.MODE === 'development') {
    root.render(<StrictMode>{app}</StrictMode>);
} else {
    root.render(app);
}
